import { Link } from 'react-router-dom';
import { useReveal } from '../lib/anim/useReveal';
import { usePageMeta } from '../lib/usePageMeta';
import { EngineCard } from '../components/EngineCard';
import { ENGINES } from '../content/engines/index';

export function EnginesIndex() {
  usePageMeta(
    'Engines — Clarity Platform',
    'Six production-ready engines proven on Onwards\' own products. Pick one, configure your wrap, and ship your micro-SaaS in 30 days.',
  );
  const heading = useReveal();

  return (
    <main className="min-h-screen text-ink" style={{ background: 'var(--color-bg)' }}>
      {/* ── Hero / Intro ── */}
      <section className="relative overflow-hidden py-28 md:py-36">
        {/* Ambient glow */}
        <div
          aria-hidden
          className="pointer-events-none absolute -top-16 left-1/2 -translate-x-1/2 w-96 h-96 rounded-full blur-3xl"
          style={{ background: 'var(--color-accent-soft)' }}
        />

        <div className="max-w-6xl mx-auto px-6 relative z-10">
          {/* Breadcrumb */}
          <nav className="mb-8" aria-label="Breadcrumb">
            <Link
              to="/"
              className="text-sm transition-colors"
              style={{ color: 'var(--color-mute)' }}
            >
              Home
            </Link>
            <span className="mx-2" style={{ color: 'var(--color-mute)' }} aria-hidden>›</span>
            <span className="text-sm" style={{ color: 'var(--color-mute)' }}>Engines</span>
          </nav>

          <div
            ref={heading.ref}
            {...heading.props}
            className={heading.props.className}
          >
            <p className="text-sm uppercase tracking-widest mb-5 font-medium" style={{ color: 'var(--color-accent)', fontFamily: 'var(--font-mono)' }}>
              The engines
            </p>
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold leading-tight tracking-tight text-ink" style={{ fontFamily: 'var(--font-display)' }}>
              Engines
            </h1>
            <p className="mt-5 max-w-2xl text-xl md:text-2xl font-normal" style={{ color: 'var(--color-mute)' }}>
              Six engines proven on Onwards' own products. Pick one, configure your wrap, ship in 30 days.
            </p>
          </div>
        </div>
      </section>

      {/* ── Engine grid ── */}
      <section className="pb-24">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {ENGINES.map((engine, i) => (
              <EngineCard
                key={engine.slug}
                engine={engine}
                delay={(i % 3) as 0 | 1 | 2}
              />
            ))}
          </div>
        </div>
      </section>

      {/* ── Footer CTA ── */}
      <section className="py-24" style={{ borderTop: '1px solid var(--color-hairline)' }}>
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-ink leading-tight" style={{ fontFamily: 'var(--font-display)' }}>
            Ready to build on a proven engine?
          </h2>
          <p className="mt-5 text-lg leading-relaxed" style={{ color: 'var(--color-mute)' }}>
            Start with Pilot at $149/mo — pick an engine, configure your wrap, and ship in 30 days.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/signup?tier=pilot"
              className="inline-flex items-center justify-center px-8 py-4 rounded font-semibold text-base hover:opacity-90 transition-opacity"
              style={{ background: 'var(--color-accent)', color: '#FFFFFF' }}
            >
              Start with Pilot — $149/mo
            </Link>
            <Link
              to="/"
              className="inline-flex items-center justify-center px-8 py-4 rounded font-medium text-base transition-colors"
              style={{ border: '1px solid var(--color-hairline)', color: 'var(--color-ink)' }}
            >
              ← Back to home
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
